<template>
  <div id="footer" class="container-fluid">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-3">
          <div class="title" @click="navTo('/products')">产品中心</div>
          <div class="row">
            <div class="col-xs-4 col-sm-4 col-md-4">
              <div class="menu-item" @click="navTo('/products/sfa')">SFA</div>
              <div class="menu-item" @click="navTo('/products/sps')">SPS</div>
              <div class="menu-item" @click="navTo('/products/tpm')">TPM</div>
              <div class="menu-item" @click="navTo('/products/dms')">DMS</div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6">
              <div class="menu-item" @click="navTo('/products/crm')">b-CRM</div>
              <div class="menu-item" @click="navTo('/products/ywym')">一物一码</div>
              <div class="menu-item" @click="navTo('/products/ai')">AI应用</div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-3">
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6">
              <div class="title" @click="navTo('/customer')">案例中心</div>
              <div class="menu-item" @click="navTo('/customer/qdpj')">青岛啤酒</div>
              <div class="menu-item" @click="navTo('/customer/mnry')">蒙牛乳业</div>
              <div class="menu-item" @click="navTo('/customer/fjjt')">汾酒集团</div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6">
              <div class="title" @click="navTo('/companyintroduction')">公司简介</div>
              <div class="title" @click="navTo('/contactus')">联系我们</div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 contucat-box">
          <div class="">
            <img class="qrcode" src="../assets/images/qrcode.png" alt="">
            <div class="dbt-box">
              <img class="logo" src="../assets/images/footer/logo-withe.png" alt="">
              <div class="phone-box">
                <img class="phone-img" src="../assets/images/footer/phone.png" alt="">
                <span class="phone-text">400-096-7686</span>
              </div>
            </div>
          </div>
          <div class="row" style="padding-top: 20px;">
            <div class=" col-sm-12 col-md-12 hidden-xs hidden-sm">
              <span class="text-item" style="margin-right: 15px;">邮箱：yangxuemin@dbtplus.com</span>
              <span class="text-item">地址：北京市东城区建国门内大街7号光华长安大厦2座518</span>
            </div>

            <div class="col-xs-12 col-sm-12 visible-xs visible-sm">
              <div class="text-item">邮箱：yangxuemin@dbtplus.com</div>
              <div class="text-item">地址：北京市东城区建国门内大街7号光华长安大厦2座518</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row copy-right">
        <div class="col-sm-6 col-md-6 hidden-xs">
          © Copyright DBT象舞创科 2006-2021京ICP备11046152号
        </div>
        <div class="col-xs-12 visible-xs">
          © Copyright DBT象舞创科
        </div>
        <div class="col-xs-12 visible-xs">
          2006-2021京ICP备11046152号
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    // 跳转
    navTo(path) {
      this.$router.push(path);
    },
  },
};
</script>
<style scoped>
#footer {
  padding: 50px 100px;
  /* width: 100%;
  height: 100%; */
  color: #fff;
  /* background: #474747; */
  overflow: hidden;
  /* text-align: center; */
  background: url("../assets/images/footer/footer-bg.png") no-repeat center center;
  background-size: cover;
}

.copy-right {
  padding: 15px 0;
  border-top: 1px solid #d3d3d3;
}

.contucat-box {
  margin-top: 15px;
  padding-left: 100px;
}

.qrcode {
  display: inline-block;
  width: 84px;
  height: 84px;
  overflow: hidden;
  border-radius: 4px;
}

.dbt-box {
  display: inline-block;
  vertical-align: top;
  margin-left: 20px;
}

.logo {
  width: 150px;
  margin-bottom: 20px;
}

.phone-box {
  display: flex;
  align-items: center;
}

.phone-img {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.phone-text {
  color: #d3d3d3;
  font-size: 20px;
  font-weight: bold;
}

.title {
  font-size: 18px;
  margin-top: 15px;
  margin-bottom: 15px;
  cursor: pointer;
}

.menu-item {
  color: #d3d3d3;
  font-size: 14px;
  margin-bottom: 10px;
  cursor: pointer;
}

.text-item {
  color: #d3d3d3;
  font-size: 14px;
  margin-bottom: 10px;
}

.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}

.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}

@media screen and (max-width: 997px) {
  #footer {
    padding: 30px;
    background: #363636;
  }

  .contucat-box{
    padding: 0 15px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {

    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue